export const actions = {
    SESSION_EXPIRED: 'SESSION_EXPIRED',
    UNAUTHORIZED_ACCESS: 'UNAUTHORIZED_ACCESS',
    FORBIDDEN_ACCESS: 'FORBIDDEN_ACCESS',
};